<template>
  <fragment>
    <!--fragment v-for="(section, index) in pageContent" :key="index">
      //
    </fragment-->
    <!-- SLIDER START -->
    <fragment>
      <carousel :slider-content="slider"/>
    </fragment>
    <!-- SLIDER END -->
    <!-- SZOLGALTATASOK SECTION START -->
    <v-container class="my-10">
      <v-row class="my-10">
        <v-col cols="12" class="mb-10">
          <!--p class="primary--text text-center">
            {{ $t('ourServices') }}
          </p-->
          <h1 class="text-center">
            {{ $t('ourServices') }}
          </h1>
        </v-col>
        <v-col cols="12" sm="6" v-for="(item, index) in $store.state.generalStore.services" :key="index">
          <v-row :justify="index % 2 === 0 ? 'end' : 'start'" :class="$vuetify.breakpoint.smAndDown ? 'px-3 mb-10' : 'px-8 mb-10'">
            <service-box v-bind:service="item" is-clickable/>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row justify="center">
            <v-btn color="primary" rounded large @click="$router.push('/services')">
              {{ $t('button.findOutMore') }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <!-- SZOLGALTATASOK SECTION END -->
    <!-- MIERT VALASSZ MINKET SECTION START -->
    <v-container fluid class="blue-stripes-bg">
      <v-container class="my-10">
        <v-row class="my-10">
          <v-col cols="12" md="4">
            <h1 class="display-2 font-weight-bold white--text">
              {{ $t('whyChooseUs') }}
            </h1>
          </v-col>
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" sm="6" v-for="(item, index) in $store.state.generalStore.whyUs" :key="index" class="pt-0">
                <why-us v-bind:why-us="item" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <!-- MIERT VALASSZ MINKET SECTION START -->
    <!-- PARTNERS SECTION START -->
    <v-container class="my-10">
      <v-row class="my-10">
        <v-col cols="12" class="mb-10">
          <!--p class="primary--text text-center">
            A high-tech szektor A-tól Z-ig
          </p-->
          <h1 class="text-center">
            {{ $t('ourPartners') }}
          </h1>
        </v-col>
        <v-col cols="12">
          <v-row justify="center" align="center">
            <v-col cols="4" sm="3" md="2" v-for="(partner, index) in $store.state.generalStore.partners" :key="index">
              <logo :logo="partner" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row justify="center">
            <v-btn color="primary" rounded large @click="$router.push('/partners')">
              {{ $t('ourPartners') }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <!-- PARTNERS SECTION START -->
  </fragment>
</template>

<script>
import { APIGETPAGECONTENT } from '../utils/apiHelper';
import carousel from '../components/carousel.vue';
import serviceBox from '../components/serviceBox.vue';
import whyUs from '../components/whyUs.vue';
import logo from '../components/logo.vue';


export default {
  components: {
    carousel, serviceBox, whyUs, logo,
  },
  data() {
    return {
      services: [],
      whyUs: [
        {
          icon: 'mdi-arrow-right-circle',
          title: 'Gyors javítás',
          desc: 'Rövid átfutási idővel, garantált minőséggel.',
        },
        {
          icon: 'mdi-arrow-right-circle',
          title: 'Magas minőség',
          desc: 'A javítás elvégzése után minden készülék szigorú tesztfolyamaton esik át.',
        },
        {
          icon: 'mdi-arrow-right-circle',
          title: 'Országos lefedettség ',
          desc: 'Ügyfeleink leadhatják a meghibásodott eszközeiket a cégünk által üzemeltetett szervizpontokon továbbá a partnerhálózatunk meghatározott pontjain.',
        },
        {
          icon: 'mdi-arrow-right-circle',
          title: 'Ügyfélközpontúság',
          desc: 'Legfőbb célunk ügyfeleink és partnereink igényeinek legmagasabb szintű kiszolgálása és elégedettségének fenntartása.',
        },
        {
          icon: 'mdi-arrow-right-circle',
          title: 'Barátságos légkör',
          desc: 'Fontosnak tarjuk a kellemes, családias hangulat fenntartását kollégáink körében.',
        },
      ],
      partners: [],
      pageContent: [],
      slider: {
        "id": 1001,
        "root_id": null,
        "code": "slider-nyito",
        "img_path": null,
        "link_url": null,
        "language": "hu",
        "name": null,
        "title": "centralEuropeSuperGrowingService",
        "desc": null,
        "child": [
          {
            "id": 1040,
            "root_id": 1001,
            "code": "button-szolgaltatasok",
            "img_path": null,
            "link_url": "services",
            "language": "hu",
            "name": null,
            "title": "button.findOutMore",
            "desc": null,
          },
        ],
      },
    };
  },
  async beforeMount() {
    // this.pageContent = await this.getPageContent();
  },
  methods: {
    async getPageContent() {
      try {
        const resp = await APIGETPAGECONTENT('nyito', 'hu');
        if (!resp.error) {
          return resp.data.page.element;
        }
        return [];
      } catch (err) {
        return [];
      }
    },
  },
  watch: {

  },
};
</script>
